module.exports = __webpack_public_path__ + "static/img/bug.c769d87a.svg";